<template>
    <div class="rank-wrap">
        <ul class="rinkList">
            <li v-for="(item, index) in rinkList" :key="index">
            <!-- <div> -->
                <p
                    class="grade"
                    :class="[index == 0 ? 'color1' : '', index == 1 ? 'color2' : '', index == 2 ? 'color3' : '']"
                >{{ item.rownum }}</p>
                <div>
                    <img class="headImg" :src="item.avatar" alt />
                    <div>
                    <p class="nickName">{{ item.nickname || '' }}</p>
                    <p class="vipDesc">{{ item.grade_name || '普通会员' }}</p>
                    </div>
                </div>
            <!-- </div> -->
             
            <p
                class="num"
                :class="[index == 0 ? 'color1' : '', index == 1 ? 'color2' : '', index == 2 ? 'color3' : '']"
            >{{ item.point }}积分</p>
            </li>
        </ul>


        <Pagination :totalPage="totalPage" :limit="form.limit" @changePage="handOrderMore" v-show="rinkList.length"></Pagination>
    </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
export default {
    components: { Pagination },
    data() {
        return {
            form: {
                page: 1,
                limit: 10
            },
            rinkList: [],
            totalPage: 0
        }   
    },
    created() {
        this.getPointRanking()
    },
    methods: {
        //分页加载
        handOrderMore(val) {
            this.form.page = val;
            this.getPointRanking();
        },
        getPointRanking() {
            this.$api.getPointRanking(this.form).then(res => {
                 this.totalPage = Math.ceil(
                    Number(res.data.count) / Number(this.form.limit)
                ) || 1;
                this.rinkList = res.data.list;
            });
        },
    }
}
</script>

<style scoped lang="scss">

.rinkList {
    color: #1a1a1a;
    font-size: 22px;
    li {
      display: flex;
      align-items: center;
    //   margin-top: 10px;
      padding: 20px 0;
      border-bottom: 1px solid #efefef;
      &:hover {
          background: #fafafa;
      }
      .grade {
        font-weight: 500;
      }
      > div {
        display: flex;
        align-items: center;
        // width: 800px;
        flex: 1;
        padding-right: 10px;
        font-size: 14px;
      }
      .headImg {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        margin-left: 20px;
        border-radius: 50%;
      }
      .nickName {
        font-weight: 300;
      }
      .vipDesc {
        color: #afafaf;
        font-size: 12px;
        margin-top: 6px;
      }
      .color1 {
        color: #fe4706;
      }
      .color2 {
        color: #fe8d4b;
      }
      .color3 {
        color: #fec200;
      }
      .num {
          text-align: right;
          min-width: 100px;
      }
    }
  }

</style>
